import { useToast } from 'vue-toastification';
import { type ToastOptions } from 'vue-toastification/src/types';
import ToastBase from './ToastBase.vue';
import { POSITION } from 'vue-toastification/src/ts/constants';

interface DescriptionPropsTypes {
  header: string;
  description: string;
  hideCloseButton?: boolean;
}

const defaultToastOptions: ToastOptions = {
  timeout: 3000,
  hideProgressBar: true,
  position: POSITION.TOP_RIGHT,
  closeButton: false,
  closeOnClick: false,
  icon: false,
};

const toastCore = useToast();

const alert =
  (type: string) => (description: string | DescriptionPropsTypes, options?: ToastOptions) => {
    return toastCore(
      {
        component: ToastBase,
        props: {
          ...(typeof description === 'string' ? { description: description } : description),
          type,
        },
      },
      {
        ...defaultToastOptions,
        ...(options ? options : {}),
      }
    );
  };

export default {
  success: alert('success'),
  error: alert('error'),
  info: alert('info'),
  loading: alert('loading'),
  clearAll: toastCore.clear,
  dismiss: toastCore.dismiss,
};
